// extracted by mini-css-extract-plugin
export default {"container":"p_-z","tab":"q_-z","selected":"r_-z"};